import { render, staticRenderFns } from "./DescriptiveSection.vue?vue&type=template&id=2d761b5c&scoped=true"
import script from "./DescriptiveSection.vue?vue&type=script&lang=js"
export * from "./DescriptiveSection.vue?vue&type=script&lang=js"
import style0 from "./DescriptiveSection.vue?vue&type=style&index=0&id=2d761b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d761b5c",
  null
  
)

export default component.exports